/* URSA standard product description layout (added 6 Oct 2026).
   Content comes from the "Description:" boxes on the product in Shopify admin (custom.desc_* metafields),
   rendered in sections/ursa-product-tools.liquid into <template id="ursa-desc-tpl">. This script moves it
   into the description area. Products with none of those boxes filled are left alone.
   A bullet list where every line contains | is shown as a table (first line = header row). */
(function () {
  'use strict';
  var tpl = document.getElementById('ursa-desc-tpl');
  if (!tpl) return;
  function tables(root) {
    root.querySelectorAll('.ud-body ul').forEach(function (ul) {
      var lis = Array.prototype.slice.call(ul.children);
      if (lis.length < 2 || !lis.every(function (li) { return li.textContent.indexOf('|') > -1; })) return;
      var tb = document.createElement('table');
      lis.forEach(function (li, i) {
        var tr = document.createElement('tr');
        li.textContent.split('|').forEach(function (c) {
          var cell = document.createElement(i ? 'td' : 'th');
          cell.textContent = c.trim();
          tr.appendChild(cell);
        });
        tb.appendChild(tr);
      });
      ul.replaceWith(tb);
    });
  }
  function apply() {
    var rte = document.querySelector('.product-details rte-formatter');
    if (!rte || rte.querySelector(':scope > .ursa-desc')) return;
    rte.dataset.ursaOff = '1';
    var frag = tpl.content.cloneNode(true);
    tables(frag);
    rte.innerHTML = '';
    rte.appendChild(frag);
  }
  apply();
  var pd = document.querySelector('.product-details');
  if (pd && window.MutationObserver) new MutationObserver(apply).observe(pd, { childList: true, subtree: true });
})();
